/**
 * Created by rathompson on 5/2/22
 * File: LabelConstants
 * Project: MSP ©Palo Alto Networks
 * © Palo Alto Networks
 */

export const LOADING_LABEL = 'Loading...'
export const LICENSE_FETCH_FAILED = 'Error: Failed to Fetch device licenses'
export const EMPTY_LICENSE = 'No License'

export const ASSOCIATION_TABLE_TITLE = 'Device Associations for'

export const BUTTON_ADD_DEVICE = 'Add Device'
export const BUTTON_ADD_DEVICES = 'Add Devices'
export const BUTTON_LEARN_MORE = 'Learn More'
export const DAS_LEARN_MORE_INK = 'https://docs.paloaltonetworks.com/common-services/device-associations/get-started'
export const BUTTON_ADD_TAGS = 'Add Tags'
export const BUTTON_ASSOCIATE_APPS = 'Associate Apps'
export const BUTTON_REMOVE_ASSOCIATIONS = 'Remove Associations'
export const BUTTON_ADD_TAG = 'Add Tag'
export const BUTTON_NEW_TAG = 'New Tag'
export const BUTTON_ADD = 'Add'
export const BUTTON_CANCEL = 'Cancel'
export const BUTTON_SAVE = 'Save'
export const BUTTON_APPLY_LICENSES = 'Apply Licenses'
export const BUTTON_REMOVE = 'Remove'
export const BUTTON_SELECT_APPLICATIONS = 'Select Applications'

export const LABEL_CREATE_NEW_TAG = 'Create a new tag'
export const LABEL_ASSOCIATE_APP = 'Associate with an App'
export const LABEL_NONE = 'None'

export const ASSOCIATION_TABLE_SEARCH_PLACEHOLDER = 'Search serial numbers, models, device names'
export const PREFIX_MODELS = 'Models'
export const PREFIX_APPS = 'Apps'

export const COLUMN_NAME = 'Device Name'
export const COLUMN_MODEL = 'Model'
export const COLUMN_ASSET_TYPE = 'Type'
export const COLUMN_SN = 'Serial Number'
export const COLUMN_ASSOCIATED_APPS = 'Associated Products'
export const COLUMN_TAGS = 'Tags'
export const COLUMN_DEVICE_LICENSES = 'Device Licenses'
export const COLUMN_CLOUD_LICENSES = 'Cloud Licenses'
export const COLUMN_LICENSE_ACTIVATED = 'License Activated'

export const TITLE_ASSOCIATE_APPS = 'Associate apps with devices'
export const TITLE_MANAGE_TAGS = 'Manage Tags'
export const TITLE_ADD_NEW_TAG = 'Add New Tag'
export const TITLE_REMOVE_APPS = 'Remove app associations'
export const TITLE_REMOVE_TSG = 'Remove tenant association'
export const TITLE_DISASSOCIATE_APPS = 'Dissociate app from device'
export const TITLE_ADD_DEVICE = 'Add devices associated with a Customer Support Account'

export const ASSOCIATION_SUCCESS = 'Applications have been associated with {0} devices for {1}.'

export const TOOLTIP_ASSOCIATING = 'Associating'
export const TOOLTIP_FAILED = 'Failed to process. Please contact Customer Support for assistance.'
export const TOOLTIP_DISSOCIATING = 'Dissociating'

export const BUTTON_REMOVE_APP_ASSC = 'Remove app association'
export const TOOLTIP_REMOVE_APP_ASSC = 'There are no app associations'

export const BUTTON_REMOVE_TSG_ASSC = 'Remove tenant association'
export const TOOLTIP_REMOVE_TSG_ASSC = 'App associations must be removed before tenant associations'

export const DEVICE_HEADING_NO_DATA = 'Choose devices to associate with this tenant'
export const DEVICE_DESC_NO_DATA = 'Add devices and then associate them with applications in this tenant.'

export const LABEL_LICENSED_PRODUCTS = 'Licensed Products'
export const LABEL_ADD_ONS = 'Add-ons'
export const LABEL_CSP = 'Customer Support Account'

export const LABEL_REMOVE_APPS = 'Would you like to continue removing the app associations?'
export const LABEL_REMOVE_TSG = 'Would you like to continue removing the tenant association?'

export const TENANT_HAS_NO_APPS = 'This tenant doesn\'t have any products.'
export const SELECT_APP_TO_CONTINUE = 'Please select an app to associate to your firewall'
export const SELECT_FIREWALLS = 'Please select a firewall'
export const FIREWALLS_ASSOCIATION_LIMIT = 'Please select up to 25 firewalls per activation'
export const FIREWALLS_LICENSES_LIMIT = 'Firewalls selection exceeded compare to available licenses'
export const SELECT_LICENSE = 'Select License'
export const SELECT_FIREWALL_LICENSE_DESCRIPTION = 'Select Firewall Model, License Type and Term'
export const DEVICE_COUNT = 'Available device licenses:'
export const MONTH = 'month'
export const DAY = 'day'
export const EVAL = 'eval'
export const TRIAL = 'trial'
export const FIREWALLS_CAP_LIMIT = 'Firewalls association exceeded compare to available licenses'

export const HUMAN_READABLE_DEVICE_LICENSE_TYPE = {
  'prod': 'Production',
  'lab': 'Lab',
  'nfr': 'NFR',
  'trial': 'Trial',
  'eval': 'Eval',
}
export const SKU_DEVICE_FETCH_FAILED = 'Error: Failed to Fetch sku compatible device'
export const DEVICE_LICENSE_FETCH_FAILED = 'Error: Failed to Fetch device license'
export const VIEW_APP_TOOLTIP = 'All devices in the tenant are automatically associated with {appName}. To de-associate with {appName}, remove device from the tenant.'
export const TOOLTIP_ADD_DEVICE_XDR_WARNING = 'This device is associated with XDR in a different region. Add the device to XDR in {tenantRegion} in order to receive logs.'
export const LABEL_BANNER_XDR_WARNING = 'This tenant is in region “{tenantRegion}” and some devices that you selected are associated with XDR in a different region. By adding these devices to this tenant, they will be associated with “{tenantRegion}” and you will need to add the device to XDR in “{tenantRegion}” in order to receive logs.'
export const BUTTON_COPY_XDR_SERIAL_NUMBERS = 'Copy Selected Device Serial Numbers'
export const LINKED_PANORAMA_DISABLED_MESSAGE = 'Panorama device cannot be removed from this tenant until it is unlinked from Cloud NGFW first.'
